module.exports = __webpack_public_path__ + "img/coupon-popup-bg.7cdbc996.png";